var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitchOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.1443 22.2857L34.2871 29.1428H27.43L21.43 35.1428V29.1428H13.7157V3.42853H41.1443V22.2857Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0015 0L3.43005 8.57143V39.4286H13.7158V48L22.2872 39.4286H29.1443L44.5729 24V0H12.0015ZM41.1443 22.2857L34.2872 29.1429H27.4301L21.4301 35.1429V29.1429H13.7158V3.42857H41.1443V22.2857Z",
    fill: "#9146FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0014 9.42859H32.5729V19.7143H36.0014V9.42859Z",
    fill: "#9146FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5727 9.42859H23.1442V19.7143H26.5727V9.42859Z",
    fill: "#9146FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchOriginal);
export default __webpack_public_path__ + "static/media/Twitch - Original.6e69e04bd9e54425991c6678a48be469.svg";
export { ForwardRef as ReactComponent };